import React from "react";
import { useDispatch } from "react-redux";
import { notification } from "../../utils/Notifications.tsx";
import { deleteComplaint } from "../../services/complaint.service.ts";
import {
  setShowDeleteModal,
  setCurrentRecord,
} from "../../store/slices/complaintsSlice.ts";
import { toCamelCase } from "../../hooks/toCameCase.tsx";

interface DeleteComplaintModalProps {
  complaint: any;
  onSuccess: () => void;
  closeFn: () => void;
}

const DeleteComplaintModal = ({
  complaint,
  onSuccess,
  closeFn,
}: DeleteComplaintModalProps) => {
  const dispatch = useDispatch();

  const handleDelete = async () => {
    try {
      await deleteComplaint(complaint.id);
      onSuccess();
      closeFn();
      notification("Eliminado", "Queja eliminada correctamente", "success");
    } catch (error: any) {
      console.error("Error al eliminar:", error);
      notification(
        "Error",
        error?.message || "No se pudo eliminar la queja",
        "danger"
      );
    }
  };

  return (
    <React.Fragment>
      <p className="fs-15px">
        ¿Estás seguro de que deseas eliminar la queja de{" "}
        {toCamelCase(complaint?.name || "")}?
      </p>
      <div className="d-flex justify-content-end">
        <button className="btn btn-secondary me-2" onClick={() => closeFn()}>
          Cancelar
        </button>
        <button className="btn btn-danger" onClick={() => handleDelete()}>
          Eliminar
        </button>
      </div>
    </React.Fragment>
  );
};

export default DeleteComplaintModal;
